import {
  EUROPE_SCHEME_CODE,
  EUROPE_VARIANT,
  WORLDWIDE_VARIANT,
} from '@/widgets/Flow/FlowSelectPlanWidget/FlowSelectPlanWidget.constants'
import type { FlowPlanVariant } from '@/shared/types/components.types'

export const getVariant = (schemecode: string): FlowPlanVariant => {
  if (schemecode === EUROPE_SCHEME_CODE) return EUROPE_VARIANT
  return WORLDWIDE_VARIANT
}
